const categorys = [...document.querySelectorAll('.p-achievement-categorys__item a')];

if(categorys.length > 1) {
  const path = location.pathname;
  const pathArray = path.split('/');
  if (pathArray.includes('reform')) {
    categorys[1].classList.add('is-current');
  
  } else if (pathArray.includes('new_build')) {
    categorys[2].classList.add('is-current');
    
  } else {
    categorys[0].classList.add('is-current');
  }
  
}

